"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = timestampToUtcString;
function timestampToUtcString(time) {
  return new Date(time * 1000).toUTCString();
}